import * as React from 'react';
import { SVGProps } from 'react';
const SvgActivityIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" stroke="#2A5993" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M19 15H5a3 3 0 0 0 0 6h14a3 3 0 0 0 0-6Zm-1-4a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM2 7l4.5-4.5L11 7l-4.5 4.5L2 7Z"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgActivityIcon;
